import React from 'react';
import { Switch } from '@kontentino/ui';
import { useTranslation } from 'react-i18next';
import { INSTAGRAM_AUDIO_TYPE_FILTERS } from '../../constants';
import type { InstagramAudioTypeFilter } from '../../types';

interface InstagramAudioTypeTabsProps {
  value: InstagramAudioTypeFilter;
  onChange: (value: InstagramAudioTypeFilter) => void;
}

const InstagramAudioTypeTabs = ({
  value,
  onChange,
}: InstagramAudioTypeTabsProps) => {
  const { t } = useTranslation();

  const labels: Record<InstagramAudioTypeFilter, string> = {
    all: t('instagramAudio.filter.all'),
    music: t('instagramAudio.filter.music'),
    original_sound: t('instagramAudio.filter.originalSound'),
  };

  return (
    <Switch.List data-name="instagram-audio_type-filter">
      {INSTAGRAM_AUDIO_TYPE_FILTERS.map((filter) => (
        <Switch.Tab
          key={filter}
          active={filter === value}
          onClick={() => onChange(filter)}
          className="!tw-h-9"
          data-cy={`instagram-audio_type-filter_${filter}`}
        >
          {labels[filter]}
        </Switch.Tab>
      ))}
    </Switch.List>
  );
};

export default InstagramAudioTypeTabs;
